// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceStyles } from "@bg/Overrides/Components/ProductPrice";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { css } from "styled-components";

productPriceStyles.price = {
    priceText: {
        size: fontConfig.fontSize.small,
        weight: fontConfig.weight.semiBold,
        lineHeight: "17px",
    },
    errorText: { weight: fontConfig.weight.bold },
    signInText: {
        color: "primary",
        size: "13px",
        lineHeight: fontConfig.lineHeight.singleLineSmall,
        weight: fontConfig.weight.semiBold,
    },
    nonStockText: {
        size: "13px",
        lineHeight: fontConfig.lineHeight.singleLineSmall,
        weight: fontConfig.weight.semiBold,
        color: "danger.main",
        css: css`
            max-width: 120px;
            display: block;
        `,
        ellipsis: true,
    },
    realTimeText: {
        weight: fontConfig.weight.bold,
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    unitOfMeasureText: {
        size: fontConfig.fontSize.small,
        lineHeight: "17px",
        transform: "uppercase",
        css: css`
            white-space: nowrap;
        `,
        weight: fontConfig.weight.semiBold,
    },
    vatLabelText: {
        size: 12,
    },
};

productPriceStyles.quoteMessage = {
    tooltip: {
        cssOverrides: {
            tooltipClickable: css`
                height: 16px;
            `,
        },
    },
    text: {
        size: fontConfig.fontSize.small,
        weight: fontConfig.weight.semiBold,
        lineHeight: "17px",
        transform: "uppercase",
    },
};
